<template>
  <div class="box">
    <div style="width:540px;height:210px">
      <vueCropper
        ref="cropperOne"
        :img="img"
        :outputSize="example2.size"
        :outputType="example2.outputType"
        :info="example2.info"
        :canScale="example2.canScale"
        :autoCrop="example2.autoCrop"
        :fixed="example2.fixed"
        :fixedNumber="fixedNumber"
        :full="true"
      ></vueCropper>
    </div>
    <div class="box">
      <div style="text-align: center;">
        <div style="padding: 10px 0" @click="changeScale(1)">
          <Icon type="android-add-circle" size="20"></Icon>
        </div>
        <div style="padding: 10px 0" @click="changeScale(-1)">
          <Icon type="android-remove-circle" size="20"></Icon>
        </div>
        <div style="padding: 10px 0" @click="rotateRight()">
          <Icon type="loop" size="20"></Icon>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {},
  props: {
    img: {
      type: String,
      default: ""
    },
    fixedNumber: {
      type: Array,
      default: [2, 1]
    }
  },
  data() {
    return {
      example2: {
        info: true,
        size: 0.8, // 输出图片质量
        outputType: "jpeg", // 输出图片格式
        canScale: true,
        autoCrop: true,
        fixed: true, // 固定裁剪框
        fixedNumber: [2, 1] // 宽度和高度比例
      }
    };
  },
  components: {},
  methods: {
    changeScale(num) {
      num = num || 1;
      this.$refs.cropperOne.changeScale(num);
    },
    rotateRight() {
      this.$refs.cropperOne.rotateRight();
    },
    finish(type) {
      // 输出
      if (type === "blob") {
        this.$refs.cropperOne.getCropBlob(data => {
          var test = window.open("");
          this.$emit("finishendOne", data);
        });
      } else {
        this.$refs.cropperOne.getCropData(data => {
          this.$emit("finishendOne", data);
        });
      }
    }
  }
};
</script>

<style>
</style>
